import React from 'react';
import Dial from './Dial';
import { getScaledColor } from '../utils/positionUtils';
import './DialCard.css';

interface DialCardProps {
  value: number; // Percentile rank (0-100)
  position: number; // Dial needle position 0-100 (mapped from percentile via logarithmic S-curve)
  label: string;
  subtext: string;
  size?: 'small' | 'large' | 'compact';
}

const DialCard: React.FC<DialCardProps> = ({ 
  value,
  position,
  label, 
  subtext,
  size = 'large'
}) => {
  const formattedValue = `${value.toFixed(1)}`;
  
  // Determine color based on position (0-100)
  const percentage = Math.max(0, Math.min(100, position));
  
  // Get scaled color from deep red (worst) to very green (best)
  const textColor = getScaledColor(percentage);
  
  return (
    <div className={`dial-card dial-card-${size}`}>
      <div className="dial-wrapper">
        <Dial position={position} />
      </div>
      <div className="dial-card-content">
        <div className="dial-value" style={{ color: textColor }}>
          {formattedValue}
        </div>
        {subtext && (
          <div className="dial-subtext">
            {subtext}
          </div>
        )}
        <div className="dial-label">
          {label}
        </div>
      </div>
    </div>
  );
};

export default DialCard;
